





































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Card from '@/components/Card.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import Switcher from '@/components/Switcher.vue'
import {
  EFacilityNcsDirectDepositAction,
  EFacilityNcsDirectDepositOptions,
  EFacilityResidentSpectialBalanceActionTypes,
  EOrigin,
  EUserPermissions,
  IFacility,
  IFacilityAdvancedSettings,
  IPayerType,
  ITemplate,
  IUser,
  EBatchTemplateFilterType,
  EBatchTemplateFilterPeriod,
  IBatchTemplate,
  ETemplateType,
  IBatch,
  isNonEmptyArray,
} from '@zunta/configurations'
import { TemplateModule } from '@/store/modules/template.module'
import { getModule } from 'vuex-module-decorators'
import { ChainModule } from '@/store/modules/chain.module'
import MultiSelectV2 from '@/components/inputsV2/MultiSelectV2.vue'
import { required } from 'vuelidate/lib/validators'
import Icon from '@/components/Icon.vue'
import BatchPayerTypeModal
  from '@/views/app/management/settings/pages/facility/batch/components/BatchPayerTypeModal.vue'
import Confirm from '@/components/Confirm.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import Editable from '@/components/inputsV2/Editable.vue'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import { getBatchCompleteLevel, getSelectContentLabel, spliceArray } from '@/utils/helpers'
import { VPopover } from 'v-tooltip'
import CircleChart from '@/components/chart/CircleChart.vue'
import StatusFacilityComplete from '@/components/statuses/StatusFacilityComplete.vue'
import InputMoney from '@/components/inputsV2/InputMoney.vue'
import { ISelectItem } from '@/interfaces'
import RadioGroup from '@/components/RadioGroup.vue'
import BatchFormTemplate from '@/views/app/management/settings/pages/facility/batch/components/BatchFormTemplate.vue'

const range = require('lodash.range')

@Component({
  components: {
    InputMoney,
    InputValidator,
    Editable,
    Confirm,
    BatchPayerTypeModal,
    Icon,
    MultiSelectV2,
    Switcher,
    LoaderWrapper,
    SelectV2,
    InputV2,
    Card,
    VPopover,
    StatusFacilityComplete,
    CircleChart,
    RadioGroup,
    BatchFormTemplate,
  },
  props: {
    batch: {
      type: Object,
      required: true
    },
    payerTypes: {
      type: Array,
      required: true
    },
    facility: {
      type: Object,
      required: true
    },
    facilityBatches: {
      type: Array
    },
    batchTemplates: {
      type: Array
    },
    defaultOpen: {
      type: Boolean,
      default: true
    },
    formDisabled: {
      type: Boolean,
      default: false
    },
    deleteDisabled: {
      type: Boolean,
      default: false
    }
  }
})
export default class BatchFormV2 extends Vue {
  templateModuleInstance: TemplateModule = getModule(TemplateModule, this.$store)
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  ADD_LETTER_TRIGGER_VALUE: string = ETemplateType.LETTER_PDF
  ADD_MESSAGE_TRIGGER_VALUE: string = ETemplateType.MESSAGE
  EFacilityNcsDirectDepositAction = EFacilityNcsDirectDepositAction
  EBatchTemplateFilterType = EBatchTemplateFilterType
  EBatchTemplateFilterPeriod = EBatchTemplateFilterPeriod
  ETemplateType = ETemplateType
  EUserPermissions = EUserPermissions
  user: User = Api.getUser() as User
  getSelectContentLabel: Function = getSelectContentLabel
  showAllExcludedPayers: boolean = false
  spliceArray = spliceArray
  updater: number = 0
  popoverOpen: boolean = false

  emptyBatchData: Partial<IFacilityAdvancedSettings> = {
    monthsBack: undefined,
    payers: this.$props.payerTypes && this.$props.payerTypes.length ? this.$props.payerTypes.map((payer: IPayerType) => payer.id) : [],
    billingContact: undefined,
    reviewUser: undefined,
    reviewStatementsBeforeMailing: true,
    name: '',
    dueDate: undefined,
    zeroBalanceAction: undefined,
    negativeBalanceAction: undefined,
    controlBalance: undefined,
    controlBalanceAction: undefined,
    ncsCollectionAction: undefined,
    ncsDirectDepositAction: undefined,
    pccBillingCycleManager: undefined,
    printedStatementUser: undefined,
    secondaryPayers: [],
    batchToCheck: undefined,
    includePreviousBreakdown: false,
    includeAdjustmentsBreakdown: false,
    excludePaymentsWriteOff: false,
    ncsDirectDepositOption: undefined,
    payersToExclude: [],
    includeAllPayers: true
  }

  batchData: Partial<IFacilityAdvancedSettings> = {
    ...this.emptyBatchData
  }

  emptyLetterObj: Partial<IBatchTemplate> = {
    id: undefined,
    facilityId: this.$props.facility.id,
    batchId: undefined,
    settingsId: this.$props.batch.id ? this.$props.batch.id : null,
    template: undefined,
    type: ETemplateType.LETTER_PDF,
    filterType: EBatchTemplateFilterType.NONE,
    payers: null
  }

  emptyMessageObj: Partial<IBatchTemplate> = {
    id: undefined,
    facilityId: this.$props.facility.id,
    batchId: undefined,
    settingsId: this.$props.batch.id ? this.$props.batch.id : null,
    template: undefined,
    type: ETemplateType.MESSAGE,
    filterType: EBatchTemplateFilterType.NONE,
    payers: null
  }

  letterTemplatesList: Partial<IBatchTemplate>[] = [{ ...this.emptyLetterObj }]
  messageTemplatesList: Partial<IBatchTemplate>[] = [{ ...this.emptyMessageObj }]

  showPayerTypeModal: boolean = false
  showIncludePayerTypeModal: boolean = false
  showConfirmDeleteModal: boolean = false

  showAllPayers: boolean = false
  showAllIncludePayers: boolean = false
  isTemplatesLoading: boolean = false

  validations (): any {
    return {
      batchData: {
        name: {
          required
        },
        billingDay: {
          // required
        },
        dueDate: {
          // required
        },
        monthsBack: {
          // required
        },
        billingContact: {
          // required
        },
        reviewUser: {
          // required
        },
        reviewStatementsBeforeMailing: {
          // required
        },
        printedStatementUser: {
          // required
        },
        zeroBalanceAction: {
          // required
        },
        negativeBalanceAction: {
          // required
        },
        controlBalance: {
          valid: (val: any) => !val || val === '' || /^-?\d+(\.\d{1,2})?$/.test(val)
        },
        controlBalanceAction: {
          // required: requiredIf(() => this.batchData.controlBalance)
        },
        ncsCollectionAction: {
          // required: requiredIf(() => !this.isPcc)
        },
        ncsDirectDepositAction: {
          // required: requiredIf(() => !this.isPcc)
        },
        ncsDirectDepositOption: {
          // required: requiredIf(() => !this.isPcc && this.batchData.ncsDirectDepositAction === EFacilityNcsDirectDepositAction.DO_NOT_INCLUDE_ON_STATEMENT)
        }
      }
    }
  }

  get requiredFields () {
    const fields = [{
      value: 'name',
      label: 'Name'
    }, {
      value: 'payers',
      label: 'Payers (at least one selected)'
    }, {
      value: 'billingDay',
      label: 'Auto Generate On'
    }, {
      value: 'dueDate',
      label: 'Bill Due Date'
    }, {
      value: 'monthsBack',
      label: 'Prior Months to Include'
    }, {
      value: 'billingContact',
      condition: this.billingContactHasAccess,
      label: 'Billing Contact'
    }, {
      value: 'reviewUser',
      condition: this.reviewUserHasAccess,
      label: 'Statements are reviewed/mailed by'
    }, {
      value: 'printedStatementUser',
      condition: this.printedStatementUserHasAccess,
      label: 'Printed Statements Delivered by '
    }, {
      value: 'zeroBalanceAction',
      label: '$0 balance statement'
    }, {
      value: 'negativeBalanceAction',
      label: 'Negative balance statement'
    }]
    if (this.selectedFacility.origin === EOrigin.NCS) {
      fields.push(...[{
          value: 'ncsCollectionAction',
          label: 'Resident is “In Collections” in NCS'
        }, {
          value: 'ncsDirectDepositAction',
          label: 'Payers Direct Deposit in NCS'
        }
      ])
      if (this.batchData.ncsDirectDepositAction === EFacilityNcsDirectDepositAction.DO_NOT_INCLUDE_ON_STATEMENT) {
        fields.push({
          value: 'ncsDirectDepositOption',
          label: 'Exclude direct deposit as of'
        })
      }
    }
    if (this.batchData.controlBalance) {
      fields.push({
        value: 'controlBalanceAction',
        label: 'Then statement'
      })
    }
    return fields
  }

  get batchCompleteLevel () {
    return +getBatchCompleteLevel(this.batchData, this.selectedFacility.origin, this.facilityUsersIds)
  }

  get completedData () {
    this.updater++
    return [{
        value: 100 - this.batchCompleteLevel,
        text: '',
        color: '#ffffff'
    },
    {
        value: this.batchCompleteLevel,
        text: '',
        color: 'currentColor'
    }]
  }

  get ncsDirectDepositOptionsList () {
    return [
      {
        key: EFacilityNcsDirectDepositOptions.START_DATE,
        value: EFacilityNcsDirectDepositOptions.START_DATE,
        content: 'NCS Direct Deposit Date'
      },
      {
        key: EFacilityNcsDirectDepositOptions.PREBILL,
        value: EFacilityNcsDirectDepositOptions.PREBILL,
        content: 'Prebill'
      },
      {
        key: EFacilityNcsDirectDepositOptions.PREBILL_1_MONTH,
        value: EFacilityNcsDirectDepositOptions.PREBILL_1_MONTH,
        content: 'Prebill and Current Month'
      },
      {
        key: EFacilityNcsDirectDepositOptions.PREBILL_2_MONTH,
        value: EFacilityNcsDirectDepositOptions.PREBILL_2_MONTH,
        content: 'Prebill, Current, and Last Month'
      }
    ]
  }

  get billingDaysOptions () {
    return range(1, 32).map((day: number) => ({
      key: day,
      value: day,
      content: day < 29 ? day : `${day} or last month day`
    }))
  }

  get monthsBackOptions () {
    return range(-1, 25).map((day: number) => ({
      key: day,
      value: day,
      content: day === -1 ? 'Pre-bill' : day === 0 ? 'From Current' : day
    }))
  }

  get dueDateOptions () {
    return [
      {
        key: 100,
        value: 100,
        content: 'Past Due'
      },
      {
        key: 101,
        value: 101,
        content: 'Upon Receipt'
      }
    ].concat(range(1, 32).map((day: number) => ({
      key: day,
      value: day,
      content: day < 29 ? day : `${day} or last month day`
    })))
  }

  get selectedFacility (): IFacility {
    return this.$props.facility
  }

  get activePayers (): IPayerType[] {
    return this.$props.payerTypes.filter((pt: IPayerType) => pt.active)
  }

  get batchPayers () {
    if (!this.batchData.payers || !this.batchData.payers.length) {
      return []
    }

    if (!this.showAllPayers) {
      return this.batchData.payers.slice(0, 5)
    }

    return this.batchData.payers
  }

  get batchIncludePayers () {
    if (!this.batchData.secondaryPayers || !this.batchData.secondaryPayers.length) {
      return []
    }

    if (!this.showAllIncludePayers) {
      return this.batchData.secondaryPayers.slice(0, 5)
    }

    return this.batchData.secondaryPayers
  }

  get facilityUsers () {
    return this.$store.state.user.users.filter((user: IUser) => {
      if (user.isAllFacilities) {
        return true
      }

      if (!this.selectedFacility || !this.selectedFacility.id) {
        return false
      }

      if (!user.facilities || !user.facilities.length) {
        return false
      }

      // @ts-ignore
      return user.facilities.includes(this.selectedFacility.id.toString())
    })
  }

  get facilityUsersOptions () {
    return this.facilityUsers.map((facilityUser: IUser) => ({
      key: facilityUser.id,
      value: facilityUser.id,
      content: `${facilityUser.firstName} ${facilityUser.lastName}`
    }))
  }

  get facilityUsersIds () {
    return this.facilityUsersOptions.map((item: any) => item.value)
  }

  get billingContactHasAccess () {
    return this.batchData.billingContact && this.facilityUsersIds.includes(+this.batchData.billingContact)
  }

  get reviewUserHasAccess () {
    return this.batchData.reviewUser && this.facilityUsersIds.includes(+this.batchData.reviewUser)
  }

  get printedStatementUserHasAccess () {
    return this.batchData.printedStatementUser && this.facilityUsersIds.includes(+this.batchData.printedStatementUser)
  }

  get facilityResidentBalanceActionsList () {
    return [{
      key: EFacilityResidentSpectialBalanceActionTypes.MARK_DO_NOT_BILL,
      value: EFacilityResidentSpectialBalanceActionTypes.MARK_DO_NOT_BILL,
      content: 'Mark as "Do Not Bill"'
    }, {
      key: EFacilityResidentSpectialBalanceActionTypes.SEND_OUT,
      value: EFacilityResidentSpectialBalanceActionTypes.SEND_OUT,
      content: 'Send Out'
    }, {
      key: EFacilityResidentSpectialBalanceActionTypes.DO_NOT_GENERATE_STATEMENT,
      value: EFacilityResidentSpectialBalanceActionTypes.DO_NOT_GENERATE_STATEMENT,
      content: 'Do Not Generate'
    }]
  }

  get isPcc () {
    return this.selectedFacility.origin === 'PCC'
  }

  get isFcc () {
    return this.selectedFacility.isFcc
  }

  get ncsDirectDepositActionsOptions () {
    return [{
      key: EFacilityNcsDirectDepositAction.INCLUDE_ON_STATEMENT,
      value: EFacilityNcsDirectDepositAction.INCLUDE_ON_STATEMENT,
      content: 'Include on Statement'
    }, {
      key: EFacilityNcsDirectDepositAction.DO_NOT_INCLUDE_ON_STATEMENT,
      value: EFacilityNcsDirectDepositAction.DO_NOT_INCLUDE_ON_STATEMENT,
      content: 'Do Not Include on Statement'
    }]
  }

  get facilityResidentNcsCollectionActionOptions () {
    return this.facilityResidentBalanceActionsList
      .filter((item) => item.key !== EFacilityResidentSpectialBalanceActionTypes.MARK_DO_NOT_BILL)
  }

  get payerTypesOptions () {
    return this.$props.payerTypes
      .filter((pt: any) => pt.active)
      .map((payer: IPayerType) => {
        return {
          key: (payer.id as number).toString(),
          value: (payer.id as number).toString(),
          content: payer.payer_name
        }
      })
  }

  get payerTypesForTemplates () {
    if (isNonEmptyArray(this.batchData.payers!) || isNonEmptyArray(this.batchData.secondaryPayers!)) {
      const filterArray = (this.batchData.payers || []).concat(this.batchData.secondaryPayers || []).map(Number)
      return this.$props.payerTypes.filter((item: any) => filterArray.includes(Number(item.id)))
    }
    return this.$props.payerTypes
  }

  getPayerTypes (secondary?: boolean) {
    const allPayerTypes = this.$props.payerTypes || []
    if (!secondary) return allPayerTypes
    const payers = (this.batchData.payers || []).map(Number)
    return allPayerTypes
      .filter((item: IPayerType) =>
        !payers.includes(item.id as number)
      )
  }

  get batchesOptions () {
    if (!this.$props.facilityBatches || !this.$props.facilityBatches.length) {
      return []
    }

    return this.$props.facilityBatches
      .filter((batch: IFacilityAdvancedSettings) => batch.id !== this.$props.batch.id)
      .map((batch: IFacilityAdvancedSettings) => {
        return {
          key: batch.id,
          value: batch.id,
          content: batch.name
        }
      })
  }

  get priorMonthLabel () {
    const label = getSelectContentLabel(this.batchData.monthsBack, this.monthsBackOptions)
    if (typeof label === 'string') return label
    return `<span class="light-grey-color">From </span>${label} Previous`
  }

  get payersToExcludeOptions () {
    let payers = this.$props.payerTypes
    const payersToOptionMap = (p: IPayerType) => {
      return {
        key: Number(p.id as number),
        // @ts-ignore
        value: p.id.toString(),
        content: p.payer_name
      }
    }
    if (!this.batchData.payers || !this.batchData.payers.length) {
      return []
    }
    return payers
      .filter((p: IPayerType) => !this.batchData.payers || !this.batchData.payers.map(Number).includes(p.id as number))
      .filter((p: IPayerType) => !this.batchData.secondaryPayers || !this.batchData.secondaryPayers.map(Number).includes(p.id as number))
      .map(payersToOptionMap)
  }

  setOpen () {
    if (!this.$props.batch.id) {
      // @ts-ignore
      this.$children[0].open()
    }
  }

  async mounted () {
    if (this.$props.batch.id || this.$props.batch.name) {
      this.batchData = this.$props.batch
      if (this.batchData.includeAllPayers) {
        this.batchData.payers = this.activePayers.map((pt: IPayerType) => pt.id as number)
      }
      this.letterTemplatesList = this.$props.batchTemplates.filter((tpl: Partial<IBatchTemplate>) => tpl.type !== ETemplateType.MESSAGE)
      this.messageTemplatesList = this.$props.batchTemplates.filter((tpl: Partial<IBatchTemplate>) => tpl.type === ETemplateType.MESSAGE)
    }

    this.$watch('batchData.payers', () => {
      if (!this.batchData.payers || !this.batchData.payers.length) {
        return
      }
      this.filterTemplatePayers()
    })

    this.$watch('batchData.secondaryPayers', () => {
      if (!this.batchData.payers || !this.batchData.payers.length) {
        return
      }
      this.filterTemplatePayers()
    })

    this.$watch('batchTemplates', () => {
      this.messageTemplatesList = this.$props.batchTemplates.filter((tpl: Partial<IBatchTemplate>) => tpl.type === ETemplateType.MESSAGE)
      if (!this.messageTemplatesList.length) {
        this.addTemplate(ETemplateType.MESSAGE)
      }

      this.letterTemplatesList = this.$props.batchTemplates.filter((tpl: Partial<IBatchTemplate>) => tpl.type !== ETemplateType.MESSAGE)
      if (!this.letterTemplatesList.length) {
        this.addTemplate(ETemplateType.LETTER)
      }
    }, { deep: true })

    this.$watch('batch', (newBatch, oldBatch) => {
      if (newBatch.id !== oldBatch.id) {
        this.batchData = this.$props.batch
      }
    }, { deep: true })
  }

  getPayerLabel (id: number | string) {
    const payer = this.$props.payerTypes.find((pt: IPayerType) => pt.id === Number(id))
    if (!payer) {
      return ''
    }

    return payer.payer_name
  }

  getPayerLabelTooltip (id: number) {
    const payer: IPayerType | null = this.$props.payerTypes.find((pt: IPayerType) => pt.id === +id)

    if (!payer) {
      return ''
    }

    let text = '<ul class="tooltip-list">'
    const li = []
    if (!this.isPcc) {
      if (payer.prebillPrev) {
        li.push(`<li class="tooltip-item">• Previous Month</li>`)
      }

      if (payer.prebillCurrent) {
        li.push(`<li class="tooltip-item">• Current Month</li>`)
      }

      if (payer.prebill) {
        li.push(`<li class="tooltip-item">• Next Month</li>`)
      }
    } else {
      if (payer.prebill) {
        li.push(`<li class="tooltip-item">• Prebill</li>`)
      }
    }

    if (!li.length) {
      return ''
    }

    text += li.join('') + '</ul>'

    return text
  }

  updateSelectedPayersList (payers: IPayerType[] | number[]) {
    this.$set(this.batchData, 'payers', this.mapPayersToNumbers(payers))
    if (this.isFcc) {
      const filteredSecondaryPayers = (this.batchData.secondaryPayers || []).filter(
        (item: number) => !(this.batchData.payers || []).includes(item)
      )
      this.updateSelectedSecondaryPayersList(filteredSecondaryPayers)
    } else {
      this.save()
    }
    this.showPayerTypeModal = false
  }

  updateSelectedSecondaryPayersList (payers: IPayerType[] | number[]) {
    const includedInPayers = (payers: number[] | undefined, payer: number) =>
      !!(payers && payers.length && payers.includes(payer))
    this.$set(this.batchData, 'secondaryPayers', this.mapPayersToNumbers(payers))
    if (this.batchData.payersToExclude && this.batchData.payersToExclude.length) {
      const filteredPayersToExclude = this.batchData.payersToExclude.filter(
        payer => !includedInPayers(this.batchData.payers, +payer) &&
          !includedInPayers(this.batchData.secondaryPayers, +payer)
      )
      this.$set(this.batchData, 'payersToExclude', filteredPayersToExclude)
    }
    this.save()
    this.showIncludePayerTypeModal = false
  }

  mapPayersToNumbers (payers: IPayerType[] | number[]) {
    const payer = payers[0]
    const typeOfPayer = typeof payer
    if (typeOfPayer === 'number' || typeOfPayer === 'string') {
      return (payers as number[])
        .map(payer => +payer)
    } else {
      return (payers as IPayerType[])
        .map(payer => payer.id as number)
    }
  }

  removePayer (payerId: number | string) {
    if (!this.batchData.payers) {
      return
    }

    const newPayers = this.batchData.payers
      .filter((item: String | Number) => Number(item) !== Number(payerId))
      .map(Number)

    // const pts = this.$props.payerTypes.filter((pt: IPayerType) => newPayers.includes(pt.id as number))
    this.updateSelectedPayersList(newPayers)
  }

  removeIncludePayer (payerId: number | string) {
    if (!this.batchData.secondaryPayers) {
      return
    }

    const newPayers = this.batchData.secondaryPayers
      .filter((item: String | Number) => Number(item) !== Number(payerId))
      .map(Number)

    const pts = this.$props.payerTypes.filter((pt: IPayerType) => newPayers.includes(pt.id as number))
    this.updateSelectedSecondaryPayersList(pts)
  }

  deleteBatch () {
    this.showConfirmDeleteModal = false
    if (this.$props.deleteDisabled) {
      return
    }
    this.$emit('remove')
  }

  saveTemplate (template: Partial<IBatchTemplate>, templateType: ETemplateType, index: number) {
    const templateList = templateType === ETemplateType.MESSAGE ? this.messageTemplatesList : this.letterTemplatesList
    templateList[index] = template
    this.save(true)
  }

  addTemplate (templateType: ETemplateType) {
    templateType === ETemplateType.MESSAGE
      ? this.messageTemplatesList.push({ ...this.emptyMessageObj })
      : this.letterTemplatesList.push({ ...this.emptyLetterObj })
  }

  deleteTemplate (templateType: ETemplateType, index: number) {
    const templateList = templateType === ETemplateType.MESSAGE ? this.messageTemplatesList : this.letterTemplatesList
    this.$emit('removeTemplate', templateList[index])
    if (!templateList[index].id) {
      templateList.splice(index, 1)
    }

    if (!templateList.length) {
      this.addTemplate(templateType)
    }
  }

  checkIfNewTemplate (triggerValue: ETemplateType, index: number) {
    if (![this.ADD_MESSAGE_TRIGGER_VALUE, this.ADD_LETTER_TRIGGER_VALUE].includes(triggerValue)) {
      return
    }
    const templateList = triggerValue === this.ADD_MESSAGE_TRIGGER_VALUE ? this.messageTemplatesList : this.letterTemplatesList
    templateList[index].template = undefined
    const route = this.$router.resolve({
      name: 'management-template',
      params: {
        templateId: 'new'
      },
      query: {
        type: triggerValue,
      }
    })
    this.$locationManager.openNewTab(route.href, true)
  }

  save (includeTemplatesSave = false) {
    if (this.$props.formDisabled) {
      return
    }
    this.$v.$touch()
    const templates = includeTemplatesSave
      ? this.letterTemplatesList
        .concat(this.messageTemplatesList)
        .filter((tpl: Partial<IBatchTemplate>) => tpl.template as number)
      : null
    const selectedAllPayers = this.batchData.payers &&
      this.batchData.payers.length === this.activePayers.length
    this.batchData.includeAllPayers = selectedAllPayers
    if (selectedAllPayers) {
      this.batchData.secondaryPayers = []
      this.batchData.payersToExclude = []
    }
    const payload = {
      batch: {
        ...this.batchData
      },
      templates,
    }
    if (!this.batchData.name) {
      payload.batch.name = 'Batch #' + (typeof this.$props.batchIndex !== 'undefined' ? this.$props.batchIndex + 1 : 1)
    }
    this.$emit('update', payload)
    if (this.$v.$anyError) {
      return
    }
    this.$emit('save', payload)
    this.updater++
  }

  filterTemplatePayers () {
    // @ts-ignore
    const valNumber: number[] = this.batchData.payers.concat(this.batchData.secondaryPayers as number[]).map(Number) || []
    this.messageTemplatesList = this.messageTemplatesList.map((tpl: Partial<IBatchTemplate>) => {
      if (!tpl.payers) { return tpl }
      const payers = (tpl.payers as number[])
        .filter((item: number | string) => valNumber.includes(Number(item))) || []
      return {
        ...tpl,
        payers: payers
      }
    })

    this.letterTemplatesList = this.letterTemplatesList.map((tpl: Partial<IBatchTemplate>) => {
      if (!tpl.payers) { return tpl }
      const payers = (tpl.payers as number[])
        .filter((item: number | string) => valNumber.includes(Number(item))) || []
      return {
        ...tpl,
        payers: payers
      }
    })
  }

  focusInput (fieldName: string) {
    // @ts-ignore
    this.$refs[`${this.batchData.id}-card`].isVisible = true
    this.$emit('open')
    if (fieldName === `${this.batchData.id}-payers`) this.showPayerTypeModal = true
    this.$eventBus.$emit(`focusInput`, fieldName)
    this.popoverOpen = false
  }
}
